// extracted by mini-css-extract-plugin
module.exports = {"IconCheckbox":"styles_IconCheckbox__3Zx5P","IconCheckbox__Input":"styles_IconCheckbox__Input__zUXNM"};